export default __webpack_public_path__ + "static/media/chardham.2c049b7f.jpg";